import { render, staticRenderFns } from "./special_price_list.vue?vue&type=template&id=97350ad8"
import script from "./special_price_list.vue?vue&type=script&lang=js"
export * from "./special_price_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports